import computed from "./computed";
import methods from "./methods";

/**
 * BURGER BUTTON
 *
 * The Burger Button Component renders the typical burger navigation toggler for
 * small devices. Its state is maintained in Vuex Store, since it needs to be
 * updated programatically from other parts of the code (e.g Router's Navigation
 * Guards. See @/router/index.js)
 *
 */
export default {
	name: "BurgerButton",
	data() {
		return {
			// this is intended to be true only before user clicks on the menu for the first time,
			// this will slightly reduce the CLS and therefore help mitigating the poor scores we are getting on GSC
			isWrapperZeroHeight: true,
		};
	},
	computed,
	methods,
};
